import styled from '@emotion/styled';
import {
  space,
  SpaceProps,
  layout,
  LayoutProps,
  border,
  BorderProps,
  flexbox,
  FlexboxProps,
  shadow,
  ShadowProps,
  color,
} from 'styled-system';
import shouldForwardProp from '@styled-system/should-forward-prop';

import {BackgroundColorProps} from '../custom-types';

type ColumnProps = SpaceProps &
  LayoutProps &
  BorderProps &
  FlexboxProps &
  ShadowProps &
  BackgroundColorProps;

export const Column = styled('div', {shouldForwardProp})<ColumnProps>`
  ${space};
  ${layout};
  ${border};
  ${flexbox};
  ${color};
  ${shadow};
  display: flex;
  flex-direction: column;
`;
